import "./index.css";
import { XIcon } from "lucide-react";
import { IconButton } from "@/ui-kit";
import { clsx } from "clsx";
import { Link } from "react-router";
import { ROUTES } from "@/router";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Logo from "@/assets/illustrations/logo.png";
import { MobileLink } from "./MobileLink";
import { useUserRole } from "@/hooks/useUserRole";

type IProps = {
  isOpen: boolean;
  onDismiss: () => void;
};

type INavLink = {
  text: string;
  url: string;
  children?: INavLink[];
};

export const MobileMenu = ({ isOpen, onDismiss }: IProps) => {
  const { t } = useTranslation();
  const { isSuperAdmin } = useUserRole();

  const rootClass = clsx("mobile-menu", isOpen && "mobile-menu--isOpen");

  const links: INavLink[] = useMemo(() => {
    const options: (INavLink | undefined)[] = [
      {
        text: t("label.projects"),
        url: ROUTES.PROJECTS,
      },
      {
        text: t("label.properties"),
        url: ROUTES.PROPERTIES,
      },
      {
        text: t("label.contracting_companies"),
        url: ROUTES.PARTNERS_CONTRACTING_COMPANIES,
      },
      {
        text: t("label.lending_companies"),
        url: ROUTES.PARTNERS_LENDERS,
      },
      {
        text: t("label.clients"),
        url: ROUTES.USERS_CLIENTS,
      },
      {
        text: t("label.inspectors"),
        url: ROUTES.USERS_INSPECTORS,
      },
      {
        text: t("label.contractors"),
        url: ROUTES.USERS_CONTRACTORS,
      },
      {
        text: t("label.admins"),
        url: ROUTES.USERS_ADMINS,
      },
      {
        text: t("label.loan_officers"),
        url: ROUTES.USERS_LOAN_OFFICERS,
      },
      {
        text: t("label.loan_processors"),
        url: ROUTES.USERS_LOAN_PROCESSORS,
      },
      {
        text: t("label.project_managers"),
        url: ROUTES.USERS_PROJECT_MANAGERS,
      },
      !isSuperAdmin
        ? {
            text: t("label.settings"),
            url: ROUTES.SETTINGS,
          }
        : undefined,
      {
        text: t("action.logout"),
        url: `/${ROUTES.SIGN_OUT}`,
      },
    ];

    return options.filter((o) => !!o) as INavLink[];
  }, [t, isSuperAdmin]);

  const linksJSX = links.map((link) => {
    return <MobileLink key={link.text} link={link} onDismiss={onDismiss} />;
  });

  return (
    <div className={rootClass}>
      <header className="mobile-menu__header">
        <Link to="/" className="nuco-header__logo-link">
          <img src={Logo} alt="QuickConnex" className="nuco-header__logo-img" />
        </Link>
        <IconButton
          size="md"
          color="layer1"
          content={<XIcon />}
          onClick={onDismiss}
        />
      </header>

      <div className="mobile-menu__main">{linksJSX}</div>
    </div>
  );
};
